import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import FormControl from '@material-ui/core/FormControl';
import Button from 'react-bootstrap-button-loader';
import Switch from '@material-ui/core/Switch';
import { Box } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import DownloadIcon from '@material-ui/icons/GetApp';
import { formatDate, isNullOrEmpty, isIOS } from '@utils';
import * as storage from '@utils/storage'
import i18next from 'i18next';
import styles from '@styles/approvalCentral.module.css';
import { download } from '@utils/download';
import { updateReadDocument } from '@actionsSup/approvalCentral';
import { getCentralApprovalTypeDescription, approvalType } from '@scripts/CentralApprovalTypeHelper';
import { getCentralApprovalStatusDescription, centralApprovalStatus } from '@scripts/CentralApprovalStatusHelper';

const useStyles = makeStyles({
    table: {
        '& td': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        '& td:first-child': {
            width: '30%',
            '@media (max-width: 600px)': {
                width: '50%'
            }
        },
    }
});

const StyledFirstTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "150px"
        },
        fontWeight: "bold"
    },
}))(TableCell);

const StyledCommentTableCellTitle = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "150px"
        },
        fontWeight: "bold",
        backgroundColor:'gainsboro'
    },
}))(TableCell);

const StyledSecondTableCell = withStyles((theme) => ({
    head: {
        color: '#000000!important',
        fontSize: 16,
        width: '75%',
        '@media (max-width: 600px)': {
            fontSize: 12,
            width: "75%"
        },
        fontWeight: 'bold'
    },
    body: {
        fontSize: 16,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

const StyledCommentTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "150px"
        },
        fontWeight: "bold"
    },
}))(TableCell);

export default function RequestDetailBankDisplay(props) {

    const classes = useStyles();
    const {
        data,
        dataRequest,
        setIsToReplace,
        isPosting,
        handleRequest,
        getIsLeaveRequest,
        getIsActionButtonShown,
        getIsDenyButtonEnabled,
        getIsApproveButtonEnabled
    } = props;
    const [isiOS] = useState(isIOS());
    const [isActive, setIsActive] = useState(false);
    const [isActionButtonShown] = useState(getIsActionButtonShown(data));
    const [isDenyButtonEnabled] = useState(getIsDenyButtonEnabled(data));
    const [isApproveButtonEnabled] = useState(getIsApproveButtonEnabled(data));
    const [denyTitle] = useState(!getIsLeaveRequest(data) && data.statusCode == centralApprovalStatus.CLOSE ? i18next.t('approvalCentral:button.cancel') : i18next.t('approvalCentral:button.deny'));

    const actionType = {
        DENY: 'R',
        APPROVE: 'F'
    }

    useEffect(() => {
        resizeForm();
    }, [])

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = isiOS ? 73 : 63;
            const customHeight = height - titleBar - offSet;
            const element = document.querySelector('#divDetailLeave');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }

            setIsActive(false);
        }, 100);
    }	

    const handleOpenDownload = (event) => {
        const dataset = event.currentTarget.dataset;
        const linkSource = `data:application/octet-stream;base64,${dataset.base64}`;

        updateReadDocument(dataset.uid).then((result) => {
            download(linkSource, `${dataset.filename}`, `application/octet-stream`);
        });        
    };

    const onToReplace = (event) => {
        setIsToReplace(event.target.checked);
    }
    
    return (
        <React.Fragment>
            <div id="divDetailLeave" className={styles.detailRequest}>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableBody>
                            <TableRow>
                                <StyledFirstTableCell>Type</StyledFirstTableCell>
                                <StyledSecondTableCell>{getCentralApprovalTypeDescription(data.approvalType)}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.employeeCode")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{data.employeeCode}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.employeeName")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{data.employeeFullName}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.status")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{getCentralApprovalStatusDescription(data.statusCode)}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.approved")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{i18next.t(`approvalCentral:table.${data.isApproved ? "yes" : "no"}`)}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.approver")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.approverName}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.approval-date")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(data.approvalDate)}</StyledSecondTableCell>
                            </TableRow>
                            {!isNullOrEmpty(dataRequest.otherClassification) && <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.otherClassification")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.otherClassification}</StyledSecondTableCell>
                            </TableRow>}
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.creation-date")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(data.creationDate)}</StyledSecondTableCell>
                            </TableRow>

                            {dataRequest.isCurrentBankShown &&
                                <>
                                    <TableRow>
                                        <StyledCommentTableCellTitle colSpan={2}><strong>{i18next.t("approvalCentral:title.bankAccountPanelTypeCurrent")}</strong></StyledCommentTableCellTitle>
                                    </TableRow>
                                    <TableRow>
                                        <StyledCommentTableCell>{i18next.t("approvalCentral:form.paymentMode")}</StyledCommentTableCell>
                                        <StyledSecondTableCell>{dataRequest.paymentModeDescription}</StyledSecondTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledCommentTableCell>{i18next.t("approvalCentral:form.institution")}</StyledCommentTableCell>
                                        <StyledSecondTableCell>{dataRequest.institNbr} - {dataRequest.institutionName}</StyledSecondTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledCommentTableCell>{i18next.t("approvalCentral:form.branchNbr")}</StyledCommentTableCell>
                                        <StyledSecondTableCell>{dataRequest.branchNbr}</StyledSecondTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledCommentTableCell>{i18next.t("approvalCentral:form.accountNbr")}</StyledCommentTableCell>
                                        <StyledSecondTableCell>{dataRequest.accountNbr}</StyledSecondTableCell>
                                    </TableRow>
                                </>
                            }

                            <TableRow>
                                <StyledCommentTableCellTitle colSpan={2}><strong>{i18next.t("approvalCentral:title.bankAccountPanelTypeDemand")}</strong></StyledCommentTableCellTitle>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.paymentMode")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{dataRequest.newPaymentModeDescription}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.institution")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{dataRequest.newInstitNbr} - {dataRequest.newInstitutionName}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.branchNbr")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{dataRequest.newBranchNbr}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.accountNbr")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{dataRequest.newAccountNbr}</StyledSecondTableCell>
                            </TableRow>

                            {dataRequest.files.length > 0 && <TableRow>
                                <StyledCommentTableCellTitle colSpan={2}><strong>{i18next.t("approvalCentral:form.files")}</strong></StyledCommentTableCellTitle>
                            </TableRow>}
                            {dataRequest.files.length > 0 && <TableRow>
                                <StyledSecondTableCell colSpan={2}>
                                    <List>
                                        {dataRequest.files.map((obj, index) =>
                                            <React.Fragment key={index}>
                                                <ListItem key={index} onClick={handleOpenDownload} button data-uid={obj.uid} data-filename={obj.filename} data-base64={obj.base64}>
                                                    <ListItemText primary={obj.filename} /><DownloadIcon />
                                                </ListItem>
                                                {dataRequest.files.length != (index + 1) && <Divider />}
                                            </React.Fragment>
                                        )}
                                    </List>
                                </StyledSecondTableCell>
                            </TableRow>}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box display="flex" justifyContent="space-evenly" marginTop={2} marginBottom={3}>
                    {isActionButtonShown && !dataRequest.isAzur &&
                        !storage.getAllowConsultation() && <LoadingOverlay
                            active={isActive}
                            spinner={<BeatLoader />}
                            text={i18next.t('approvalCentral:form.loading')}
                        >
                            <FormControl fullWidth>
                                <Button
                                    onClick={(event) => handleRequest(event, data, actionType.APPROVE)}
                                    className={`approveButton ${styles.buttonStyle} ${(isPosting || !isApproveButtonEnabled) ? styles.buttonDisabled : ""}`}
                                    variant="success"
                                >
                                    {i18next.t('approvalCentral:button.approve')}
                                </Button>
                            </FormControl>
                        </LoadingOverlay>
                    }

                    {isActionButtonShown && !dataRequest.isAzur &&
                        !storage.getAllowConsultation() && <LoadingOverlay
                            active={isActive}
                            spinner={<BeatLoader />}
                            text={i18next.t('approvalCentral:form.loading')}
                        >
                            <FormControl fullWidth>
                                <Button
                                    onClick={(event) => handleRequest(event, data, actionType.DENY)}
                                    className={`denyButton ${styles.buttonStyle} ${(isPosting || !isDenyButtonEnabled) ? styles.buttonDisabled : ""}`}
                                    variant="success"
                                >
                                    {denyTitle}
                                </Button>
                            </FormControl>
                        </LoadingOverlay>
                    }
                </Box>

            </div>
        </React.Fragment>
    );
}

RequestDetailBankDisplay.propTypes = {
    data: PropTypes.object.isRequired,
    dataRequest: PropTypes.object.isRequired
}